import React from "react";

/**
 * Loading Status Component
 * Shows appropriate text based on the current loading state
 * 
 * @param {Object} props Component properties
 * @param {boolean} props.isInitializing Whether data is being initialized
 * @param {boolean} props.isUploading Whether files are being uploaded
 * @param {boolean} props.isSaving Whether data is being saved
 */
const LoadingStatus = ({ isInitializing, isUploading, isSaving }) => {
  if (isInitializing) return "Loading settings...";
  if (isUploading) return "Uploading files...";
  if (isSaving) return "Saving settings...";
  return "Save Settings";
};

export default LoadingStatus; 